// DR-2-A single-flight guard: coalesce overlapping auth-triggered provisioning calls into ONE
// in-flight request. While a call is running, every overlapping caller awaits the same Promise;
// no second HTTP request is issued. The in-flight reference clears in `finally` (after success OR
// terminal failure) so a later legitimate provisioning attempt can run. Pure, dependency-free.
export function makeSingleFlight(fn) {
  let inflight = null;
  return (...args) => {
    if (inflight) return inflight;
    try {
      inflight = Promise.resolve(fn(...args)).finally(() => {
        inflight = null;
      });
    } catch (e) {
      inflight = null;
      return Promise.reject(e);
    }
    return inflight;
  };
}
